import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import { ISettingsApiData, IAppControlsUpdateReq, IAppControlsUpdateRes, IAppControlsGetRes } from "../../../_models/settings.model";
import { HttpParams } from "@angular/common/http";
import { IAppResponse } from "../../../_interceptors/network-error.model";

@Injectable({
  providedIn: "root",
})
export class SettingService {
  public endpoint: string = "admin";
  constructor(private apiService: ApiService) { }

  getAll(sortBy?: string | null, sortOrder?: string | null) {
    let params = new HttpParams({
      fromObject: {
        ...(sortBy && { sortBy: sortBy }),
        ...(sortOrder && { sortOrder: sortOrder }),
      },
    });

    return this.apiService.get<ISettingsApiData>({
      Url: `${this.endpoint}/subscription-plans`,
      Params: params
    });
  }

  createPlan(body: any) {
    return this.apiService.post<any, any>({
      Url: `${this.endpoint}/subscription-plans/create`,
      Body: body
    });
  }

  updateSubscriptionPlan(data: any) {
    return this.apiService.put<any, any>({
      Url: `${this.endpoint}/subscription-plans/update`,
      Body: data
    });
  }

  updateAppControls(data: IAppControlsUpdateReq) {
    return this.apiService.put<IAppControlsUpdateReq, IAppResponse>({
      Url: `${this.endpoint}/settings/app-controls`,
      Body: data
    });
  }
  getAppControls() {
    return this.apiService.get<IAppControlsGetRes>({
      Url: `/settings`,
    });
  }

}
